import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AssetsService } from 'src/app/services/assets.service';

@Component({
  selector: 'app-all-assets',
  templateUrl: './all-assets.component.html',
  styleUrls: ['./all-assets.component.css'],
})
export class AllAssetsComponent implements OnInit, AfterViewInit {
  constructor(
    private fb: UntypedFormBuilder,
    private assetsService: AssetsService,
  ) {}

  statusFilter = 'Active';
  assetTypeFilter = 'All';
  assetTypes: string[] = [
    'All',
    'Car',
    'Laptop',
    'Mobile',
    'Monitor',
    'Other',
    'SIM',
    'Fuel Card',
  ];
  loading = true;
  pageLoading = false;
  allAssets: AllAssets[] = [];
  dataSource = new MatTableDataSource<AllAssets>([]);

  ngOnInit(): void {
    this.loadAssets(this.statusFilter);
  }

  loadAssets(status: string) {
    this.statusFilter = status;
    this.loading = true;
    this.assetsService.fetchAllAsset(this.statusFilter).subscribe(
      (res) => {
        console.log(res);
        this.allAssets = res.map((e: any) => ({
          assetId: e.assetId,
          assetType: e.assetType,
          assetAssignedToEmp: e.assetAssignedToEmp,
          empAssignedDate: e.empAssignedDate,
          status: e.status,
          mobileNumber: e.mobileNumber,
          car: e.number,
          leaseEndDate: e.leaseEndDate,
          // keep compatibility key and expose raw model/serial separately
          electronicDevice: e.electronicModel,
          electronicModel: e.electronicModel,
          electronicSerialNumber: e.electronicSerialNumber,
          price: e.cataloguePrice,
          fuelCard: e.fuelCard,
          comments: e.comments,
        }));
        this.updateDataSource();
        this.loading = false;
      },
      () => {
        this.loading = false;
      },
    );
  }

  displayedColumns: string[] = [
    'assetId',
    'assetType',
    'assetAssignedToEmp',
    'mobileNumber',
    'car',
    'electronicDevice',
    'price',
    'fuelCard',
    'comments',
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.paginator.page.subscribe(() => {
      this.showPageLoader();
    });
    this.dataSource.filterPredicate = (data: AllAssets, filter: string) => {
      const search = filter.trim().toLowerCase();
      const assetType = data.assetType?.toLowerCase() || '';
      const escapedSearch = search.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
      const assetTypeMatch = new RegExp(`\\b${escapedSearch}\\b`).test(
        assetType,
      );
      const otherFieldsMatch = Object.keys(data).some((key) => {
        if (key === 'assetType') {
          return false;
        }
        const value = (data as any)[key];
        return (
          value !== undefined &&
          value !== null &&
          value.toString().toLowerCase().includes(search)
        );
      });
      return assetTypeMatch || otherFieldsMatch;
    };
  }

  showPageLoader() {
    this.pageLoading = true;
    setTimeout(() => {
      this.pageLoading = false;
    }, 150);
  }

  trackByAssetId(index: number, item: AllAssets) {
    return item.assetId || index;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  onAssetTypeChange(value: string) {
    this.assetTypeFilter = value;
    this.updateDataSource();
  }

  private updateDataSource() {
    let filteredAssets = this.allAssets;
    if (this.assetTypeFilter && this.assetTypeFilter !== 'All') {
      filteredAssets = filteredAssets.filter(
        (asset) =>
          asset.assetType?.toLowerCase() === this.assetTypeFilter.toLowerCase(),
      );
    }

    this.dataSource.data = filteredAssets;
  }
}

export interface AllAssets {
  assetId: string;
  assetType: string;
  assetAssignedToEmp: string;
  empAssignedDate: Date;
  status: string;
  mobileNumber: string;
  car: string;
  leaseEndDate: Date;
  electronicDevice: string;
  electronicModel?: string;
  electronicSerialNumber?: string;
  price: string;
  fuelCard: string;
  comments: string;
}
